import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import {
  GradeFilterPanel,
  GradeFilterWrap,
  UnitRangeChevronIcon,
  UnitRangeMenuOption,
  UnitRangePillButton,
} from './component.styles'

const UnitRangeDropdown = ({ options, unitRangeLabel }) => {
  const [open, setOpen] = useState(false)
  const [selectedLabel, setSelectedLabel] = useState(
    () => unitRangeLabel || options[0] || '',
  )
  const wrapRef = useRef(null)

  useEffect(() => {
    setSelectedLabel(unitRangeLabel || options[0] || '')
  }, [unitRangeLabel])

  useEffect(() => {
    if (!open) return undefined
    const close = e => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [open])

  useEffect(() => {
    if (!open) return undefined
    const onKey = e => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open])

  return (
    <GradeFilterWrap ref={wrapRef}>
      <UnitRangePillButton
        aria-expanded={open}
        aria-haspopup="listbox"
        data-testid="unit-range-dropdown-trigger"
        onClick={() => setOpen(o => !o)}
        type="button"
      >
        {selectedLabel}
        <UnitRangeChevronIcon aria-hidden className="fas fa-angle-down" />
      </UnitRangePillButton>
      {open && (
        <GradeFilterPanel aria-label="Unit range" role="listbox">
          {options.map((option, index) => (
            <UnitRangeMenuOption
              aria-selected={selectedLabel === option}
              data-testid={`unit-range-option-${index}`}
              key={option}
              onClick={() => {
                setSelectedLabel(option)
                setOpen(false)
              }}
              role="option"
              type="button"
            >
              {option}
            </UnitRangeMenuOption>
          ))}
        </GradeFilterPanel>
      )}
    </GradeFilterWrap>
  )
}

UnitRangeDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  unitRangeLabel: PropTypes.string,
}

export default UnitRangeDropdown
